define.alias("ember-composable-helpers/helpers/union", "media/helpers/union");